import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionsRoutingModule } from './sections-routing.module';
import { SectionToolbarComponent } from './section-toolbar/section-toolbar.component';
import { CoreUIModule } from '../core-ui/core-ui.module';
import { SectionEditToolbarComponent } from './section-edit-toolbar/section-edit-toolbar.component';
import { EditNotificationControlComponent } from './notifications/edit-notification-control/edit-notification-control.component';

@NgModule({
	imports: [
		CommonModule,
		CoreUIModule,
		SectionsRoutingModule
	],
	declarations: [
		SectionToolbarComponent,
		SectionEditToolbarComponent,
		EditNotificationControlComponent,
	],
	exports: [
		SectionToolbarComponent,
		SectionEditToolbarComponent,
		EditNotificationControlComponent
	],
	providers: []
})
export class SectionsModule {}
